export const sampleData = {
  "company": "YourBrand Inc.",
  "website": "https://formatally.com",
  "founded": 2020,
  "isActive": true,
  "headquarters": {
    "city": "San Francisco",
    "state": "CA",
    "country": "USA"
  },
  "products": [
    {
      "name": "Product Alpha",
      "category": "Software",
      "price": 99.99
    },
    {
      "name": "Product Beta",
      "category": "Hardware",
      "price": 299.99
    },
    {
      "name": "Product Gamma",
      "category": "Service",
      "price": 19.99,
      "subscription": "monthly"
    }
  ],
  "employees": 125,
  "executives": [
    {
      "name": "Jane Doe",
      "position": "CEO",
      "yearsWithCompany": 3
    },
    {
      "name": "John Smith",
      "position": "CTO",
      "yearsWithCompany": 2
    }
  ]
};

export const JsonToGoSampleData = {
  "user": {
    "id": 1,
    "name": "John Doe",
    "email": "john@example.com",
    "is_active": true,
    "created_at": "2023-01-01T00:00:00Z",
    "role": "admin",
    "settings": {
      "notifications": true,
      "theme": "dark"
    },
    "scores": [85, 90, 78],
    "tags": ["developer", "go"]
  },
  "status": "success",
  "count": 1
}

export const JsonToSwiftSampleData = {
  "user": {
    "id": 123,
    "name": "John Doe",
    "email": "john@example.com",
    "isActive": true,
    "roles": ["admin", "user"],
    "address": {
      "street": "123 Main St",
      "city": "San Francisco",
      "zipCode": "94105"
    },
    "settings": {
      "notifications": {
        "email": true,
        "push": false
      },
      "theme": "dark"
    },
    "lastLoginAt": "2023-04-01T12:00:00Z"
  }
};

export const JsonToKotlinSampleData = {
  "id": 1,
  "name": "John Doe",
  "email": "john.doe@example.com",
  "age": 30,
  "isActive": true,
  "scores": [85, 90, 78],
  "address": {
    "street": "123 Main St",
    "city": "New York",
    "zipCode": "10001"
  },
  "tags": ["developer", "kotlin"],
  "projects": [
    {
      "id": 101,
      "title": "Mobile App",
      "completed": false
    },
    {
      "id": 102,
      "title": "Web Portal",
      "completed": true
    }
  ]
};

export const JsonToProtobufSampleData = {
    user: {
      id: 1001,
      name: "John Doe",
      email: "john@example.com",
      is_active: true,
      age: 30
    },
    preferences: {
      theme: "dark",
      notifications: true,
      newsletter: false
    },
    posts: [
      {
        id: 1,
        title: "First Post",
        content: "This is my first post",
        tags: ["welcome", "intro"]
      },
      {
        id: 2,
        title: "Second Post",
        content: "This is my second post",
        tags: ["update"]
      }
    ],
    meta: {
      last_login: "2023-04-15T10:30:00Z",
      account_created: "2022-01-20T08:15:30Z"
    }
  };

export const JsonToBsonSampleData = {
  _id: { $oid: "507f1f77bcf86cd799439011" },
  name: "John Doe",
  age: 30,
  email: "john.doe@example.com",
  isActive: true,
  tags: ["developer", "mongodb", "javascript"],
  address: {
    street: "123 Main St",
    city: "New York",
    state: "NY",
    zip: "10001"
  },
  created: { $date: "2022-01-01T00:00:00Z" },
  scores: [98.5, 87.2, 92.1],
  metadata: null
};